import React from 'react';
import {
  Alert,
  AlertTitle,
  CircularProgress,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { Close, CheckCircleOutline } from '@mui/icons-material';

export interface CreateProjectStatusProps {
  loading: boolean;
  open: boolean;
  creatingProject: boolean;
  creatingProjectError: boolean;
  contacts: { pending: number; created: number; failed: number };
  attachments: { pending: number; created: number; failed: number };
  close: Function;
}

export const CreateProjectStatus = ({
  loading,
  open,
  creatingProject,
  creatingProjectError,
  contacts,
  attachments,
  close,
}: CreateProjectStatusProps) => {
  const content = (
    <Alert
      variant="filled"
      severity="success"
      sx={
        contacts.failed > 0 || attachments.failed > 0 || creatingProjectError
          ? { backgroundColor: 'warning.main' }
          : { backgroundColor: 'secondary.main' }
      }
      icon={
        loading ? (
          <CircularProgress color="inherit" size={22} />
        ) : (
          <CheckCircleOutline fontSize="inherit" />
        )
      }
      action={
        loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    >
      <AlertTitle>
        <Typography variant="h6">
          {creatingProject
            ? 'Creating Project...'
            : (contacts.failed > 0 || attachments.failed > 0) &&
              !creatingProjectError
            ? 'Created Project with Errors'
            : creatingProjectError
            ? 'Error Creating Project'
            : 'Created Project'}
        </Typography>
      </AlertTitle>
      <Typography variant="subtitle2">
        The project was created successfully
      </Typography>
      {contacts.created + contacts.pending + contacts.failed > 0 && (
        <Typography variant="subtitle2">
          {contacts.pending > 0 ? 'Creating' : 'Created'} Project Contacts:{' '}
          {contacts.created}/
          {contacts.created + contacts.pending + contacts.failed} succeeded
          &nbsp;&nbsp;&nbsp;{' '}
          {contacts.failed > 0 && `${contacts.failed} FAILED!`}
        </Typography>
      )}
      {attachments.created + attachments.pending + attachments.failed > 0 && (
        <Typography variant="subtitle2">
          {attachments.pending > 0 ? 'Uploading' : 'Uploaded'} Project
          Attachments: {attachments.created}/
          {attachments.created + attachments.pending + attachments.failed}{' '}
          succeeded &nbsp;&nbsp;&nbsp;{' '}
          {attachments.failed > 0 && `${attachments.failed} FAILED!`}
        </Typography>
      )}
    </Alert>
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={!loading ? 3000 : null}
      onClose={() => close()}
      message={content}
      open={open}
      ContentProps={{
        sx:
          contacts.failed > 0 || attachments.failed > 0 || creatingProjectError
            ? { backgroundColor: 'warning.main' }
            : { backgroundColor: 'secondary.main' },
      }}
      action={
        !loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    />
  );
};
